/*
 * @Author: Gary 
 * @Date: 2017-10-31 12:04:47 
 * @Last Modified by: Gary
 * @Last Modified time: 2018-04-09 18:01:44
 */

const app = {
  state: {
    // 侧边栏伸缩
    sidebar: {
      opened: false
    },
    windowHeight: 500
  },
  mutations: {
    toggleSidebar: state => {
      state.sidebar.opened = !state.sidebar.opened;
    },
    handleSidebar: (state, type) => {
      state.sidebar.opened = type;
    },
    setWindowHeight: (state, val) => {
      state.windowHeight = val;
    },
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js